import * as React from 'react';
import { Helpers } from '@grandvisionhq/inventory';
import { useCart } from '../../../context/Cart/context.js';
import '@swc/helpers';
import '@grandvisionhq/common';
import '@grandvisionhq/graphql';
import '@grandvisionhq/state';
import '@grandvisionhq/utils';
import '../../../models/add-to-cart/add-to-cart.js';
import '../../../models/cart/cart.js';
import '../../../models/subscription/subscription-details.js';
import '../../../models/checkoutState/checkoutState.js';
import '../../../utils/cart-count-var.js';
import '../../../utils/cart-id-var.js';
import '@grandvisionhq/commercetools';
import '../../../utils/get-unrecoverable-validation-errors.js';
import '../../../models/line-item/prescription-glasses.js';
import '../../../utils/get-failure-error-codes.js';
import '../../../utils/get-validation-errors-by-line-item.js';
import '@grandvisionhq/lib-visuals';
import '../../../operations/fragments/cart-details.js';
import '../../../operations/fragments/cart-validation-errors.js';
import '../../../operations/fragments/recover-inactive-cart-failure.js';
import '../../../operations/fragments/recover-inactive-cart-result.js';
import '../../../operations/mutations/add-cart-line-items.js';
import '../../../operations/mutations/add-cart-voucher-codes.js';
import '../../../operations/mutations/create-cart.js';
import '../../../operations/mutations/create-cart-from-instant-checkout-link.js';
import '../../../operations/mutations/create-cart-from-order.js';
import '../../../operations/mutations/duplicate-cart-line-items.js';
import '../../../operations/mutations/remove-cart-voucher-codes.js';
import '../../../operations/mutations/remove-cart-line-items.js';
import '../../../operations/mutations/update-cart-line-items.js';
import '../../../operations/mutations/replace-line-item-contact-lenses-bundle-benelux.js';
import '../../../operations/mutations/recover-inactive-cart.js';
import '../../../operations/queries/get-cart.js';
import '../../../operations/queries/get-total-line-items.js';
import '../../../operations/queries/get-cart-estimated-delivery.js';
import '../../../context/CartSettings/context.js';
import 'classnames';
import '@grandvisionhq/elements';
import '@grandvisionhq/shipping';
import { RemoveLineItemContainer } from '../containers/RemoveLineItemContainer.js';
import { UpdateLineItemContainer } from '../containers/UpdateLineItemContainer.js';
import { DuplicateLineItemContainer } from '../containers/DuplicateLineItemContainer.js';

const QuantitySelector = ({ lineItemId , readOnly , showQuantity , showDuplicateButton  })=>{
    const { cart  } = useCart();
    const lineItem1 = cart === null || cart === void 0 ? void 0 : cart.lineItems.filter((lineItem)=>lineItem.id === lineItemId
    )[0];
    if (!lineItem1) {
        return null;
    }
    return !readOnly && !lineItem1.isGift ? /*#__PURE__*/ React.createElement("div", {
        className: "line-item__quantity"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "line-item__quantity-selector"
    }, showQuantity && /*#__PURE__*/ React.createElement(UpdateLineItemContainer, {
        lineItem: lineItem1,
        availableQuantity: Helpers.getAvailableQuantity(lineItem1.availability)
    }), showDuplicateButton && /*#__PURE__*/ React.createElement(DuplicateLineItemContainer, {
        lineItem: lineItem1
    }), /*#__PURE__*/ React.createElement("div", {
        className: "line-item__delete-btn"
    }, /*#__PURE__*/ React.createElement(RemoveLineItemContainer, {
        lineItem: lineItem1
    })))) : null;
};

export { QuantitySelector };
//# sourceMappingURL=QuantitySelector.js.map
